<template lang="pug">
  .germany
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/germany-min.png"
      )
      span {{ gettext('Германия') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content
      div
        p {{ gettext('Страна объединяет 16 федеральных земель в одну республику, с населением около 80 миллионов человек и является активным членом Евро Союза. Экономика Германии стабильная и развитая, крупнейшая по своим показателям в Европе. Германия является центром бизнеса, промышленных технологий, индустрии, металлургии, сельского хозяйства и транспорта.') }}
        p {{ gettext('Развитый социализм в этой демократической стране обеспечивает всех своих и иностранных граждан (имеющих вид на жительство) достойным уровнем социальной защиты в плане здравоохранения и социальных услуг.') }}
        p {{ gettext('Естественно, что при таком высоком росте и обширном развитии экономики необходимо большое количество квалифицированных кадров и сезонных работников для поддержания деятельности и функционирования всех производственных мощностей. Поэтому огромное количество иммигрантов стремятся работать или хотя бы пройти практику именно в Германии. Только в 2017 году из третьих стран мира в Германию въехало около 1,22 млн иммигрантов.') }}
        p {{ gettext('Стоит заметить, что найти работу в этой стране задача не из простых, поскольку Германия не рада наплыву неквалифицированной рабочей силы. Но всегда остаются востребованными: технические профессии (слесари, сантехники, электрики, механики), медицинский персонал (медсестры, специалисты по уходу за пожилыми людьми), строители. Большую роль играют сезонные рабочие, без которых сельскохозяйственный сектор попросту не существовал бы. Особенно остро стоит вопрос с человеческими ресурсами в сфере транспорта. В Германии нужны водители, как по региональным перевозкам, так и международным, чтобы доставлять огромное количество немецких товаров на полки маркетов и снабжать предприятия.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
      div
        .about-boxes
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/visa-rules`")
            span {{ gettext('Visa rules') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-conditions`")
            span {{ gettext('Working conditions') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/accommodation`")
            span {{ gettext('Accommodation') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/healthcare`")
            span {{ gettext('Healthcare') }}

</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/germany-min.png'})
  },
  name: 'Germany',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Germany  | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/germany/index.vue